import { useEffect, useRef, useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import { useHistory } from 'react-router';
import { useAppContext } from '../../../appProvider/contextProvider';
import {  getDrips, addDrip, updateDrip, disableDrip, deleteDrip } from '../../../services/automationService';
import getCroppedImage from '../../../Util/getCroppedImage';
import IconCropper from '../../../components/IconCropper/iconCropper';
import { ERRORS, URL_VALIDATOR } from '../../../constants/AppConstants';
import { toast } from 'react-toastify';
import DripNotificationPreview from '../../../components/NotificationPreview/DripNotificationPreview';
import DeletePrompt from '../../../components/Propmts/deletePrompt';
import { getOverAllStats } from '../../../services/overAllStats';
import roundOff from '../../../Util/roundOff';



const DripNotification = () => {

    const history = useHistory();

    const bannerRef = useRef(null);
    const iconRef = useRef(null);

    const [ drips, setDrips ] = useState([]);

    const {selectedWebsite,
        setPathToNavigate,
        setDiscardPromptOpen,
        isDirty, 
        setIsDirty,
        setIsBgDisabled
    } = useAppContext();


    const [title, setTitle] = useState('');
    const [titleError, setTitleError] = useState(null);

    const [message, setMessage] = useState('');
    const [messageError, setMessageError] = useState(null);
    const [messageLengthError, setMessageLengthError] = useState(null);


    const [landingUrl, setLandingUrl] = useState('');
    const [landingUrlError, setLandingUrlError] = useState(null);

    const [iconPath, setIconPath] = useState('');
    const [iconName, setIconName]= useState('');
    const [openCropper, setOpenCropper] = useState(false);
    const [icon, setIcon] = useState(null);    
    const [iconDisplayPath, setIconDisplayPath] = useState('');

    const [bannerPath, setBannerPath] = useState('');
    const [bannerName, setBannerName]= useState('');
    const [openBannerCropper, setOpenBannerCropper] = useState(false);
    const [banner, setBanner] = useState(null);
    const [bannerDisplayPath, setBannerDisplayPath] = useState('');

    const [ isCTAEnabled, setCTAEnabled] = useState(true);    
    const [isCTA2Enabled, setCTA2Enabled] = useState(false);

    const [button, setCta1Title] = useState('');
    const [cta1TitleError, setCTA1TitleError] = useState(null);
    const [cta1URL, setCta1URL] = useState('');
    const [cta1URLError, setCTA1URLError] = useState(null);


    const [addl_button, setCta2Title] = useState('');
    const [cta2TitleError, setCTA2TitleError] = useState(null);
    const [cta2URL, setCta2URL] = useState('');
    const [cta2URLError, setCTA2URLError] = useState(null);

    const [scheduledAt , setScheduledAt]= useState('1');
    const [scheduledAtError, setScheduledAtError] = useState(null);
    const [scheduledType, setScheduledType] = useState('minute');

    const [isInEditMode, setInEditMode] = useState(false);
    const [editId, setEditId] = useState('');

    const [deletePrompt, setDeletePromp] = useState(false);

    const [dripStats, setDripStats] = useState({});

    const [selectedDrip, setSelectedDrip] = useState(null);

    useEffect(() => {
        const discard = () => {
            resetForm();
        }
        document.addEventListener('discardEvent', discard);

        return () => {
            document.removeEventListener('discardEvent', discard);
        }
    }, [])

    useQuery(['fetchDrips', selectedWebsite?.id], () => getDrips(selectedWebsite?.id), {
        enabled: !!selectedWebsite,
        onSuccess: (drips) => {
            if(drips.errors) {

            }else {
                setDrips(drips);
            }
        }
    } );

    useQuery(
        ['fetchDripNotificationStats', selectedWebsite?.id], 
        () => getOverAllStats(selectedWebsite?.id),
        {
            enabled: !!selectedWebsite,
            onSuccess: (stats) => {
                setDripStats(stats.drip);
            }
        }
    )

    const handelIconUpload = (({target}) => {
        if(target.files && target.files[0]) {
            const url = URL.createObjectURL(target.files[0]);
            setIconName(target.files[0].name);
            setIconPath(url);
            setOpenCropper(true);
            iconRef.current.value = '';
            setIsDirty(true);
        }
    });

    const onCancelIconCrop = () => {
        if(selectedDrip && selectedDrip?.icon) {
            setIconPath(selectedDrip?.icon);
        } else {
            setIconPath('');
        }
        setIconDisplayPath('');
        setOpenCropper(false);
        setIconName('');
    }
    
    const getCroppedIcon = async (croppedAreaPixel) => {
        const {url, file} = await getCroppedImage(
            iconPath,
            croppedAreaPixel,
            0,
            iconName,
        );
        setIconPath(url);
        setIconDisplayPath(url);
        setIcon(file);
        setOpenCropper(false);
    }


    const handelBannerUpload = (({target}) => {
        if(target.files && target.files[0]) {
            const url = URL.createObjectURL(target.files[0]);
            setBannerName(target.files[0].name);
            setBannerPath(url);
            setOpenBannerCropper(true);
            bannerRef.current.value ='';
            setIsDirty(true);
        }
    });

    const onCancelBannerCrop = () => {
        if(selectedDrip && selectedDrip?.banner_image) {
            setBannerPath(selectedDrip?.banner_image);
        } else {
            setBannerPath('');
        }
        setBannerDisplayPath('')
        setOpenBannerCropper(false);
        setBannerName('');
    }
    
    const getCroppedBanner = async (croppedAreaPixel) => {
        const {url, file} = await getCroppedImage(
            bannerPath,
            croppedAreaPixel,
            0,
            bannerName,
        );
        setBannerDisplayPath(url);
        setBannerPath(url);
        setBanner(file);
        setOpenBannerCropper(false);
    }

    const handelTitleChange = (value) => {
        if(value.trim().length <=0 ) {
            setTitleError(ERRORS.TITLE_REQUIRED);
        }
        else {
            setTitleError(null);
        }
        if(value.trim().length <= 100 ) {
            setTitle(value);
        }
        setIsDirty(true);
    }

    const handelMessageChange = (value) => {
        
        if(value.trim().length >= 120 ) {
            setMessageLengthError(ERRORS.WEBSITE_MESSAGE_MAX_LENGTH);
        }
        else {
            setMessageError(null);
        }
        if(value.trim().length <= 300 ) {
            setMessage(value);
        }
        setIsDirty(true);
    }

    const handelLandingPageUrlChange = (value) => {
        
        if(value.trim().length <=0 ) {
            setLandingUrlError(ERRORS.LANDING_PAGE_URL_REQUIRED);
        } else if(!value.match(URL_VALIDATOR)) {
            setLandingUrlError(ERRORS.WEBSITE_URL_VALID);
        }
        else {
            setLandingUrlError(null);
        }
        if(value.trim().length <= 150 ) {
            setLandingUrl(value);
        }
        setIsDirty(true);
    }

    const handelCTA1TitleChange = (value) => { 
        if(value.trim().length <=0 ) {
            setCTA1TitleError(ERRORS.TITLE_REQUIRED);
        }
        else {
            setCTA1TitleError(null);
        }
        if(value.trim().length <= 20 ) {
            setCta1Title(value);
        }
        
        setIsDirty(true);
    }

    const handelCTA1URLChange = (value) => {
        
        if(value.trim().length <=0 ) {
            setCTA1URLError(ERRORS.WEBSITE_URL_REQUIRED);
        } else if(!value.match(URL_VALIDATOR)) {
            setCTA1URLError(ERRORS.WEBSITE_URL_VALID);
        }
        else {
            setCTA1URLError(null);
        }
        if(value.trim().length <= 150 ) {
            setCta1URL(value);
        }
        setIsDirty(true);
    }

    const handelCTA2TitleChange = (value) => {
        
        if(value.trim().length <=0 ) {
            setCTA2TitleError(ERRORS.TITLE_REQUIRED);
        }
        else {
            setCTA2TitleError(null);
        }
        if(value.trim().length <= 20 ) {
            setCta2Title(value);
        }
        setIsDirty(true);
    }

    const handelCTA2URLChange = (value) => {
        if(value.trim().length <=0 ) {
            setCTA2URLError(ERRORS.WEBSITE_URL_REQUIRED);
        } else if(!value.match(URL_VALIDATOR)) {
            setCTA2URLError(ERRORS.WEBSITE_URL_VALID);
        }
        else {
            setCTA2URLError(null);
        }
        if(value.trim().length <= 150 ) {
            setCta2URL(value);
        }
        setIsDirty(true);
    }

    const handelScheduleTimeChange = (value) => {
        setScheduledAt(value);
        if(value.length <=0 ) {
            setScheduledAtError(ERRORS.SCHEDULE_AT_TILE_REQUIRED);
        } else if(!value.match(/^\d+$/)) {
            setScheduledAtError(ERRORS.INVALID_SCHEDULE_AT);
        }
        else {
            setScheduledAtError(null);
        }
        setIsDirty(true);
    }


    const isSaveDisabled = () => {
        return title.length <= 0 || landingUrl.length <= 0 || scheduledAt.length <= 0 || 
        titleError || messageError || landingUrlError || scheduledAtError ||
        (isCTAEnabled && ( button.length <= 0 || cta1URL.length <= 0 || cta1TitleError || cta1URLError)) ||
        (isCTA2Enabled && ( addl_button.length <= 0 || cta2URL.length <= 0 || cta1TitleError || cta1URLError ));
    }


    const addDripNotification = useMutation((formData) => {
        return addDrip(selectedWebsite?.id, formData) }, {
            onSuccess: ((dripData) => {
                if(dripData.errors) {
                    toast.error('Something went wrong');
                } else {
                    const tempDrip = drips;
                    tempDrip.push(dripData);
                    setDrips(tempDrip);
                    toast.success('The Drip Notification is added successfully.');
                    resetForm();
                }
            //    setOpenDialogue(false);
            }),
            onError: ((error) => {
                console.log(error);
                // toast.error(error.message);
            })
        }
    );


    const save = (event) => {
        event.preventDefault();
        const formData = new FormData();
        formData.append('title', title);
        formData.append('message', message);
        formData.append('scheduled_at', `${scheduledAt} ${scheduledType}`);
        formData.append('landing_url', landingUrl);
        formData.append('is_cta_enabled', isCTAEnabled);
        if(isCTAEnabled) {
            formData.append('button', button);
            formData.append('url', cta1URL);
            if(isCTA2Enabled) {
                formData.append('addl_button', addl_button);
                formData.append('addl_url', cta2URL);
            } else {
                formData.append('addl_button', '');
                formData.append('addl_url', '');
            }
        } else {
            formData.append('button', '');
            formData.append('url', '');
            formData.append('addl_button', '');
            formData.append('addl_url', '');
        }
        if(banner) {
            formData.append('banner_image', banner);
        } else if(!banner) {
            formData.append('banner_image', '');
        }
        if(icon) {
            formData.append('icon', icon);
        }else if(!icon) {
            formData.append('icon', '');
        }
        addDripNotification.mutate(formData);
    }

    const edit = (drip) => {
        setSelectedDrip(drip);
        setInEditMode(true);
        setEditId(drip?.id || '');
        setTitle(drip?.title|| '');
        setMessage(drip?.message|| '');
        setLandingUrl(drip?.landing_url|| '');
        setCTAEnabled(drip?.is_cta_enabled|| '');
        if(drip?.is_cta_enabled) {
            setCta1Title(drip?.button|| '');
            setCta1URL(drip?.url|| '');
        }
        if(drip?.addl_button) {
            setCTA2Enabled(true|| '');
            setCta2Title(drip?.addl_button|| '');
            setCta2URL(drip?.addl_url|| '')
        }
        const [scheduledTime, scheduleType] = drip?.scheduled_at.split(' ');
        setScheduledAt(scheduledTime|| '0');
        setScheduledType(scheduleType|| 'second');
        if(drip?.banner_image) {
            const url = drip.banner_image.split('/');
            setBannerName(url[url.length -1]);
            setBannerPath(drip?.banner_image);
            setBannerDisplayPath(drip?.banner_image)
        } else if(!drip?.banner_image) {
            setBannerName('');
            setBannerPath('');
            setBannerDisplayPath('')
        }
        if(drip?.icon) {
            const url = drip.icon.split('/');
            setIconName(url[url.length -1]);
            setIconDisplayPath(drip?.icon);
            setIconPath(drip?.icon);
        } else if(!drip?.icon) {
            setIconName('');
            setIconDisplayPath('');
            setIconPath('');
        }
    }

    const update = (event) => {
        event.preventDefault();
        const formData = new FormData();
        formData.append('title', title);
        formData.append('message', message);
        formData.append('scheduled_at', `${scheduledAt} ${scheduledType}`);
        formData.append('landing_url', landingUrl);
        formData.append('is_cta_enabled', isCTAEnabled);

        if(isCTAEnabled) {
            formData.append('button', button);
            formData.append('url', cta1URL);
            if(isCTA2Enabled) {
                formData.append('addl_button', addl_button);
                formData.append('addl_url', cta2URL);
            } else {
                formData.append('addl_button', '');
                formData.append('addl_url', '');
            }
        } else {
            formData.append('button', '');
            formData.append('url', '');
            formData.append('addl_button', '');
            formData.append('addl_url', '');
        }
        if(banner) {
            formData.append('banner_image', banner);
        } else if(!banner && !bannerPath) {
            formData.append('banner_image', '');
        }
        if(icon) {
            formData.append('icon', icon);
        }else if(!icon && !iconPath) {
            formData.append('icon', '');
        }
        updateDripNotification.mutate(formData);
    }

    const updateDripNotification = useMutation((formData) => {
        return updateDrip(selectedWebsite?.id, editId, formData) }, {
            onSuccess: ((updatedDrip) => {
                if(updatedDrip.errors) {
                } else {
                    const tempDrips = drips.map((drip) => {
                        if(drip.id === updatedDrip.id) {
                            return updatedDrip;
                        }
                        return drip;
                    });
                    setDrips(tempDrips);
                    toast.success('The Drip Notification is Updated successfully.');
                    resetForm();
                }
            }),
            onError: ((error) => {
                console.log(error);
            })
        }
    );

    const disable = (event, dripId, is_active) => {
        event.preventDefault();
        disableDripNotification.mutate({dripId: dripId, is_active: !is_active})
    }

    const disableDripNotification = useMutation(({dripId ,is_active}) => {
        return disableDrip(selectedWebsite?.id, dripId, is_active) }, {
            onSuccess: ((updatedDrip, {is_active}) => {
                if(updatedDrip.errors) {
                } else {
                    const tempDrips = drips.map((drip) => {
                        if(drip.id === updatedDrip.id) {
                            return updatedDrip;
                        }
                        return drip;
                    });
                    toast.success(!is_active ? 'The Drip is disabled successfully': 'The Drip is enabled successfully');
                    setDrips(tempDrips);
                    
                }
            //    setOpenDialogue(false);
            }),
            onError: ((error) => {
                console.log(error);
            })
        }
    );

    const resetForm = () => {
        setTitleError(null);
        setMessageError(null);
        setMessageLengthError(null)
        setLandingUrlError(null);
        setScheduledAtError(null);
        setCTA1TitleError(null);
        setCTA2TitleError(null);
        setCTA1URLError(null);
        setCTA2URLError(null);

        setSelectedDrip(null);
        setInEditMode(false);
        setTitle('');
        setMessage('');
        setLandingUrl('');
        setBanner(null);
        setIcon(null);
        setCTAEnabled(false);
        setCta1Title('');
        setCta2Title('');
        setCta1URL('');
        setCta2URL('');
        setCTA2Enabled(false);
        setScheduledAt(0);
        setScheduledType('second');
        setIconName('');
        setIconPath('');
        setBannerName('');
        setBannerPath('');

        setIsDirty(false);
    }

    
    const discard = () => {
        setDiscardPromptOpen(true);
    }

   
    const onClearBanner = () => {
        setIsDirty(true);
        setBanner(null);
        setBannerPath('');
        setBannerName('');
        setBannerDisplayPath('');
    }

    
    const onClearIcon = () => {
        setIsDirty(true);
        setIcon(null);
        setIconPath('');
        setIconName('');
        setIconDisplayPath('');
    }

    const onCancelEdit = () => {
        setInEditMode(false);
        resetForm();
    }

    const delDrip = useMutation(() => {
        return deleteDrip(selectedWebsite?.id, editId);
    }, {
        onSuccess: (drip) => {

            if(drip?.errors) {

            } else {
                const remainingDrips = drips.filter(({id}) => id !== editId);
                setDrips(remainingDrips);
                toast.success('Drip Deleted Successfully');
            }            
            setEditId(null);
            setInEditMode(false);
        }
    });

    const deleteSelectedDrip = (dripId) => {
        setIsBgDisabled(true);
        setEditId(dripId);
        setDeletePromp(true);
    }


    const onDelete = (event) => {
        event.preventDefault();
        setIsBgDisabled(false);
        setDeletePromp(false);
        delDrip.mutate();
    }

    const onDeleteCancel = () => {
        setEditId(null);
        setIsBgDisabled(false);
        setDeletePromp(false);
    }


    const deleteCta1 = () => {
        setIsDirty(true);
        setCTAEnabled(!isCTAEnabled);
        setCta1Title('');
        setCta1URL('');
        setCTA1TitleError(null);
        setCTA1URLError(null);
        deleteCta2();
        setIsDirty(true);
    }

    const deleteCta2 = () => {
        setIsDirty(true);
        setCTA2Enabled(false);
        setCta2Title('');
        setCta2URL('');
        setCTA2TitleError(null);
        setCTA2URLError(null);
        setIsDirty(true);
    }

    const goBack = () => {
        if(isDirty) {
            setDiscardPromptOpen(true);
            setPathToNavigate('/basic-automation');
        } else {
            history.push('/basic-automation');
        }
    }

    return <>
        { deletePrompt && <DeletePrompt onDelete={onDelete} onCancel={() => onDeleteCancel(false)} />}
        <div className="panel full-height">
                        <div className="panel-header">
                            <div className="d-flex flex-wrap justify-content-between align-items-space-between">
                                <div>
                                <h3 className="mb-0 medium"><i className="icon icon-chevron-left mr-2" onClick={() => goBack()}></i> Drip Notification Setup</h3>
                                </div>
                                <div className="d-flex justify-content-between " style={{gap: '10px'}}>
                                    <button className="btn btn-sm btn-danger" disabled={!isDirty} onClick={() => discard()} >Discard</button>
                                    {
                                        isInEditMode ?
                                        <button className="btn btn-sm btn-primary" onClick={update} disabled={isSaveDisabled()}>
                                            Update Drip Notification
                                        </button>
                                        : 
                                        <button className="btn btn-sm btn-primary" onClick={save} disabled={isSaveDisabled()}>
                                            Add Drip Notification
                                        </button>
                                    }                                         
                                </div> 
                            </div> 
                        </div>
                        <div className="panel-body d-flex flex-column scrollable_y">
                            <div className="row">
                                <div className="col">
                                    <div className="panel panel-bordered mb-3">
                                        <div className="panel-header">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <h5 className="medium mb-0">Drip Notification Content</h5>
                                            </div>                                
                                        </div>
                                        <div className="panel-body d-flex flex-column scrollable_y">
                                        <div className="row">
                                            <div className="col-12 col-lg-6">
                                                    <p className="thin text-light">A sequence of notifications sent to the subscriber once
                                                        they subscribe to your store notifications</p>
                                            </div>
                                            <div className="col col-lg-2">
                                                <label className="thin text-light">Sent</label>
                                                <h5 className="text-dak">{roundOff(dripStats?.sent)}</h5>
                                            </div>
                                            <div className="col col-lg-2">
                                                <label className="thin text-light">Impressions</label>
                                                <h5 className="text-dak">{roundOff(dripStats?.delivered)}</h5>
                                            </div>
                                            <div className="col col-lg-2">
                                                <label className="thin text-light">Clicks</label>
                                                <h5 className="text-dak">{roundOff(dripStats?.opened)}</h5>
                                            </div>
                                        </div>
                                        <div className="row flex-column scrollable_y p-15">
                                            <div className="form-group">                   
                                                <div className="d-flex justify-content-between">
                                                    <label className="form-label text-dark medium">Title *</label>
                                                    <div>{title.length} / 100</div>
                                                </div>
                                                <div className="input-addon input-group-right">
                                                    <i className="icon icon-edit"></i>
                                                    <input 
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Notification Title"
                                                        value={title}
                                                        onChange={({target}) => handelTitleChange(target.value)}
                                                        maxLength={100}    
                                                    />                        
                                                </div>
                                                { titleError && <div><span className="error-message">{titleError}</span></div>}  
                                            </div>
                                            <div className="form-group">                   
                                                <div className="d-flex justify-content-between">
                                                    <label className="form-label text-dark medium">Message</label>
                                                    <div>{message.length} / 300</div>
                                                </div>
                                                <textarea 
                                                    type="text"
                                                    className="form-control"
                                                    rows="4"
                                                    value={message}
                                                    placeholder="Notification Message"
                                                    onChange={({target}) => handelMessageChange(target.value)}
                                                    maxLength={300}
                                                ></textarea>  
                                                { messageError && <div><span className="error-message">{messageError}</span></div>}                      
                                                { messageLengthError && <div><span className="error-message">{messageLengthError}</span></div>}
                                            </div>
                                            <div className="form-group">                   
                                                <div className="d-flex justify-content-between">
                                                    <label className="form-label text-dark medium">Landing Page Url *</label>
                                                    <div>{landingUrl.length} / 150</div>
                                                </div>
                                                <div className="input-addon input-group-right">
                                                    <i className="icon icon-website"></i>
                                                    <input 
                                                        type="text"
                                                        className="form-control"
                                                        value={landingUrl}
                                                        onChange={({target}) => handelLandingPageUrlChange(target.value)}
                                                    />                                                             
                                                </div>  
                                                <span>Note: After clicking the push notification, the subscribers will see the complete URL of the web pages they visited. For instance, https://blog.chirpyweb.com</span>                       
                                                { landingUrlError && <div><span className="error-message">{landingUrlError}</span></div>}
                                            </div>
                                            <div className="form-group">
                                                <label className="medium">Banner Image</label>
                                                <div className="d-flex">                                                        
                                                    <div className="form-group mb-0">                                                            
                                                        <div className="d-flex align-items-center">
                                                            <div className="file-upload">                                                             
                                                                <input 
                                                                    type="file"
                                                                    accept="image/*"
                                                                    onChange={(event) => handelBannerUpload(event)}
                                                                    ref={bannerRef}
                                                                />
                                                                <i className="icon icon-file"></i>
                                                                Select File                                                            
                                                            </div>
                                                            {bannerDisplayPath && <span className="mx-2 image-name">{bannerName}</span>}
                                                        </div>                                                          
                                                    </div>
                                                    {/* <span className="image-name" >{bannerName}</span> */}
                                                    {bannerDisplayPath && <button className="btn ml-2 btn-grey" onClick={() => onClearBanner()} ><i className="icon icon-close mr-2"></i>Clear</button>}
                                                </div> 
                                                <span>Note: The image will appear inside the push notification received by your readers on chrome on windows, Recommended size 360X240 (2:1 Aspect Ratio).</span>                                                   
                                            </div>
                                            <div className="form-group">
                                                <label className="medium">Icon</label>
                                                <div className="d-flex">                                                        
                                                    <div className="form-group mb-0"> 
                                                        <div className="d-flex align-items-center">
                                                            <div className="file-upload">                                                             
                                                                <input 
                                                                    type="file"
                                                                    accept="image/*"
                                                                    onChange={(event) => handelIconUpload(event)}    
                                                                    ref={iconRef}
                                                                />
                                                                <i className="icon icon-file"></i>                       
                                                                Select File                                        
                                                            </div>
                                                            {iconDisplayPath && <span className="mx-2 image-name">{iconName}</span>}
                                                        </div>                                                                                                                   
                                                    </div>
                                                      
                                                    {iconDisplayPath && <button className="btn ml-2 btn-grey" onClick={() => onClearIcon()} ><i className="icon icon-close mr-2"></i>Clear</button>}
                                                </div> 
                                                <span>Note: This image will be used as icon only for this push notification.</span>                                                   
                                            </div>
                                            <div className="panel no-shadow">
                                                <div className="panel-header m-0 d-flex">
                                                    <h6 className="mb-0 medium mr-3">CTA’s </h6>
                                                    <label className="toggle-control toggle-control-sm mb-2">
                                                        <input type="checkbox" checked={isCTAEnabled} onChange={() => deleteCta1()} />
                                                        <span className="control"></span>
                                                    </label>
                                                </div>
                                                <div className="panel-body px-0" style={{display : isCTAEnabled ? 'block' : 'none'}}>
                                                    <>
                                                        <h6 className="medium">Button 1</h6>
                                                        <hr className="my-3"/>
                                                        <div className="form-row">
                                                            <div className="form-group col-12 col-md-6 col-xl-4">   
                                                                <div className="d-flex justify-content-between">
                                                                    <label className="form-label text-dark medium">Title *</label>
                                                                    <div>{button.length} / 40</div>
                                                                </div>           
                                                                <div className="">
                                                                    <input 
                                                                        type="text" 
                                                                        placeholder="Eg. Read More" 
                                                                        className="form-control"
                                                                        value={button}
                                                                        onChange={({target}) => handelCTA1TitleChange(target.value)}    
                                                                    />                        
                                                                </div> 
                                                                { cta1TitleError && <div><span className="error-message">{cta1TitleError}</span></div>} 
                                                            </div>
                                                            <div className="form-group col-12 col-md-6 col-xl-4">  
                                                                <div className="d-flex justify-content-between">
                                                                    <label className="form-label text-dark medium">Landing URL *</label>
                                                                    <div>{cta1URL.length} / 150</div>
                                                                </div>
                                                                <div className="input-addon input-group-right">
                                                                    <input 
                                                                        type="text" 
                                                                        placeholder="e.g. https://chirpyweb.com" 
                                                                        className="form-control url-wrapper"
                                                                        value={cta1URL}
                                                                        onChange={({target}) => handelCTA1URLChange(target.value)}    
                                                                    />                        
                                                                </div>
                                                                { cta1URLError && <div><span className="error-message">{cta1URLError}</span></div>}   
                                                            </div>
                                                        </div> 
                                                    </>
                                                    { isCTA2Enabled && <>
                                                        <h6 className="medium">Button 2</h6>
                                                        <hr className="my-3"/>
                                                        <div className="form-row">
                                                            <div className="form-group col-12 col-md-6 col-xl-4">   
                                                                <div className="d-flex justify-content-between">
                                                                    <label className="form-label text-dark medium">Title *</label>
                                                                    <div>{addl_button.length} / 40</div>
                                                                </div>           
                                                                <div className="">
                                                                    <input 
                                                                        type="text" 
                                                                        placeholder="Eg. Read More" 
                                                                        className="form-control"
                                                                        value={addl_button}
                                                                        onChange={({target}) => handelCTA2TitleChange(target.value)}    
                                                                        />                        
                                                                </div>  
                                                                { cta2TitleError && <div><span className="error-message">{cta2TitleError}</span></div>} 
                                                            </div>
                                                            <div className="form-group col-12 col-md-6 col-xl-4">  
                                                                <div className="d-flex justify-content-between">
                                                                    <label className="form-label text-dark medium">Landing URL *</label>
                                                                    <div>{cta2URL.length} / 150</div>
                                                                </div>
                                                                <div className="input-addon input-group-right">
                                                                    <input 
                                                                        type="text" 
                                                                        placeholder="e.g. https://chirpyweb.com" 
                                                                        className="form-control url-wrapper"
                                                                        value={cta2URL}
                                                                        onChange={({target}) => handelCTA2URLChange(target.value)} 
                                                                    />                        
                                                                </div>
                                                                { cta2URLError && <div><span className="error-message">{cta2URLError}</span></div>}   
                                                            </div>
                                                        </div> 
                                                    </>}
                                                    
                                                    { !isCTA2Enabled && <button className="btn btn-outline" onClick ={() => setCTA2Enabled(true)} ><i className="icon icon-add mr-2"></i>Add another</button>}
                                                    { isCTA2Enabled && <button className="btn btn-danger" onClick ={() => deleteCta2()} ><i className="icon icon-delete mr-2"></i>Delete another</button>}
                                                    <hr className="my-3"/>
                                                </div>
                                                <div className="row mt-2">
                                                        <div className="col-12 col-sm-6">
                                                            <label className="text-dark medium">Schedule After *</label>
                                                            <div className="row">
                                                                <div className="form-group col-6">
                                                                    <input type="number" min="1" value={scheduledAt} onChange={({target}) => handelScheduleTimeChange(target.value)} className="form-control"/>
                                                                    {scheduledAtError && <span className="error-message">{scheduledAtError}</span>}
                                                                    <div><span className="text-light thin">From the previous Drip notification delivery.</span></div>
                                                                </div>
                                                                <div className="col-6">
                                                                    <div className="custom-select">
                                                                        <select value={scheduledType} onChange={({target}) => setScheduledType(target.value)} className="form-control">
                                                                            <option value='second' >Second(s)</option>
                                                                            <option value='minute'>Minute(s)</option>
                                                                            <option value='hour'>Hour(s)</option>
                                                                            <option value='day'>Day(s)</option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>                                                
                                                
                                            </div> 
                                        </div>                              
                                    </div>

                                    </div>
                                </div>
                                <DripNotificationPreview
                                    drips= {drips}
                                    edit={edit}
                                    disable={disable}
                                    editMode={isInEditMode}
                                    activeDrip={[{
                                        title,
                                        message,
                                        button: button,
                                        addl_button: addl_button,
                                        banner: bannerDisplayPath,
                                        icon: iconDisplayPath,
                                        scheduled_at: `${scheduledAt} ${scheduledType}`,
                                        is_cta_enabled: isCTAEnabled,
                                        isCTA2Enabled: (isCTAEnabled && isCTA2Enabled)
                                    }]}
                                    onCancel={onCancelEdit}
                                    deleteDrip={deleteSelectedDrip}
                                    // title={title}
                                    // message={message}
                                    // banner={bannerPath}
                                    // icon={iconPath}
                                    // cta1Title={ is_cta_enabled ? cta1Title : null}
                                    // cta2Title={ (is_cta_enabled && isCTA2Enabled) ? cta2Title : null}
                                />
                            </div>
                        </div>
                    </div>

        { openCropper && <IconCropper
                open={openCropper} 
                onClose={onCancelIconCrop} 
                url={iconPath} 
                onSave={getCroppedIcon}
                aspect={1/1}
            />
        }
        { openBannerCropper && <IconCropper
                    open={openBannerCropper} 
                    onClose={onCancelBannerCrop} 
                    url={bannerPath} 
                    onSave={getCroppedBanner}
                    aspect={2/1}
                />}
    </>
}


export default DripNotification;